export const joinFormatted = arr =>
  arr.reduce(
    (a, b, i, array) =>
      a + (i < array.length - 1 ? ', ' : arr.length === 2 ? ' and ' : ', and ') + b
  );

export const joinOrFormatted = arr =>
  arr.reduce(
    (a, b, i, array) => a + (i < array.length - 1 ? ', ' : arr.length === 2 ? ' or ' : ', or ') + b
  );

export const addRange = (arr, items) => arr.push(...items);
